import { useState, useEffect } from 'react';
import { Modal, Button, Form, Input, Message } from 'semantic-ui-react';
import Swal from 'sweetalert2';
import authService from 'src/services/api/auth';

const UserEditModal = ({ open, onClose, user, onSuccess }) => {
  const [email, setEmail] = useState(user?.email || '');
  const [name, setName] = useState(user?.name || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (user) {
      setEmail(user.email || '');
      setName(user.name || '');
      setError('');
    }
  }, [user]);

  const handleSubmit = async () => {
    if (!name || !name.trim()) {
      setError('El nombre es requerido');
      return;
    }

    if (!email || !email.trim()) {
      setError('El email es requerido');
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('El email no es válido');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await authService.editUser({
        id: user.id,
        email: email.trim(),
        name: name.trim(),
      });

      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          title: 'Usuario actualizado',
          text: 'El email ha sido actualizado correctamente.',
          timer: 2000,
          showConfirmButton: false,
        });
        onSuccess();
      } else {
        throw new Error(response.data.message || 'Error al actualizar el usuario');
      }
    } catch (error) {
      console.error('Error updating user:', error);
      setError(
        error.response?.data?.message || error.message || 'No se pudo actualizar el usuario.'
      );
    } finally {
      setLoading(false);
    }
  };

  if (!user) return null;

  return (
    <Modal open={open} onClose={onClose} size="small">
      <Modal.Header>Editar Email de Usuario</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field>
            <label>Nombre</label>
            <Input
              value={user.name || 'Sin nombre'}
              onChange={(e) => {
                setName(e.target.value);
                setError('');
              }}
            />
          </Form.Field>
          <Form.Field>
            <label>Email</label>
            <Input
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError('');
              }}
              placeholder="Ingresa el nuevo email"
              error={!!error}
            />
            {error && <Message negative>{error}</Message>}
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button primary onClick={handleSubmit} loading={loading}>
          Guardar Cambios
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default UserEditModal;
